"use strict";

exports.__esModule = true;
exports.AdSolutionClient = void 0;
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _index = require("../constants/index.js");
var _adPlacementPayloadFactory = require("../factories/ad-placement-payload.factory.js");
var AdSolutionClient = exports.AdSolutionClient = {
  fetchAdPlacements: function fetchAdPlacements(payload, baseURL, env) {
    var requestId = 'AD_SOLUTION_FETCH_REQUEST';
    var host = "" + baseURL + _index.HOSTS.AD_SOLUTION.PATHNAME;
    var endpoint = host + _index.ENDPOINTS.AD_SOLUTION.FETCH_AD_PLACEMENTS;
    return _http.$http.post(requestId, endpoint, {
      data: (0, _adPlacementPayloadFactory.adPlacementPayloadFactory)(payload, env === _index.ENV.LIVE)
    }).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  },
  sendInteraction: function sendInteraction(requestURL) {
    var requestId = "AD_SOLUTION_INTERACTION_REQUEST_" + requestURL;
    return _http.$http.get(requestId, requestURL, {}).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  }
};